
import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'

import genericFormFields from 'shared/services/genericFormFields'

import { sendUnauthenticatedGetRequestToAPI } from 'modules/generators/requestsToAPI'
import { getFormSuccess as setFormModuleActiveForm } from 'user/pages/Form/module'

export const GET_FORMS_REQUEST = 'FormsList/GET_FORMS_REQUEST'
export const GET_FORM_SUCCESS = 'FormsList/GET_FORM_SUCCESS'
export const GET_FORM_ERROR = 'FormsList/GET_FORM_ERROR'

export const SET_ACTIVE_FORM = 'FormsList/SET_ACTIVE_FORM'

export function getFormsRequest (formsIds) {
  return {
    type: GET_FORMS_REQUEST,
    payload: formsIds
  }
}

export function getFormSuccess (form) {
  return {
    type: GET_FORM_SUCCESS,
    payload: form
  }
}

export function getFormError (error) {
  return {
    type: GET_FORM_ERROR,
    payload: error
  }
}

export function setActiveForm (formId) {
  return {
    type: SET_ACTIVE_FORM,
    payload: formId
  }
}

export function getActiveFormSelector (state) {
  return state.formsList.activeForm &&
    state.formsList.forms &&
    find(state.formsList.forms, {'id': state.formsList.activeForm})
}

export function getActiveFormFieldsSelector (state) {
  const activeForm = getActiveFormSelector(state)
  return activeForm &&
    [...genericFormFields(),
      ...sortBy(activeForm.form_fields, 'order')]
}

export function getFirstFormIdSelector (state) {
  return state.formsList.forms && sortBy(state.formsList.forms, 'order')[0].id
}

export function * getFormsGenerator (action) {
  const formsIds = action.payload

  yield all(formsIds.map(formId => (
    call(
      sendUnauthenticatedGetRequestToAPI,
      `/widget/form/${formId}/`,
       getFormSuccess,
       getFormError)
  )))

  const firstFormId = yield select(getFirstFormIdSelector)
  yield put(setActiveForm(firstFormId))
}

export function * setActiveFormGenerator (action) {
  const form = yield select(getActiveFormSelector)
  yield put(setFormModuleActiveForm(form))
}

export function * getFormsSaga () {
  yield takeEvery(GET_FORMS_REQUEST, getFormsGenerator)
}

export function * setActiveFormSaga () {
  yield takeEvery(SET_ACTIVE_FORM, setActiveFormGenerator)
}

const initialState = {
  activeForm: null,
  error: null,
  forms: []
}

/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */
export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_FORMS_REQUEST:
      return {
        ...state,
        forms: [],
        error: null
      }
    case GET_FORM_SUCCESS:
      return {
        ...state,
        forms: [...state.forms, action.payload]
      }
    case GET_FORM_ERROR:
      return {
        ...state,
        error: action.payload
      }
    case SET_ACTIVE_FORM:
      return {
        ...state,
        activeForm: action.payload
      }
    default:
      return state
  }
}

export default reducer
